<template>
    <div class="summary-view">
        <h4>{{ pointItem.name }}</h4>        
        <table class="table text-center">
            <thead>
                <th>Variable</th>
                <th>Forecast value</th>
                <th>Historical value</th>
            </thead>
            <tbody>
                <!--<tr v-for="varItem in pointItem.values" :key="varItem.varid">
                    <td>{{ varItem.name }}</td>
                    <td>{{ formatValue(varItem.forecast[selMonthIndex], varItem.forecastUnits) }}</td>
                    <td>{{ formatValue(varItem.historical[selMonthIndex], varItem.historicalUnits) }}</td>
                </tr>-->
                <tr v-for="varItem in getVarItems" :key="varItem.varid">
                    <td>{{ varItem.name }}</td>                    
                    <td v-if="varItem.hasForecastValue"><div class="color-item" :style="{ backgroundColor: varItem.forecastColor  }"></div><br/>{{ varItem.forecastLabel }}{{ varItem.forecastUnits }}</td>
                    <td v-else>N/A</td>
                    <td v-if="varItem.hasHistoricalValue"><div class="color-item" :style="{ backgroundColor: varItem.historicalColor  }"></div><br/>{{ varItem.historicalLabel }}{{ varItem.historicalUnits }}</td>
                    <td v-else>N/A</td>
                </tr>
            </tbody>
        </table>        
    </div>
</template>

<script>

import logger from '@/lib/logger.js'

export default {
    name: 'SummaryView',
    data() {
        return {
            pointItem: this.item,
            selMonthIndex: 0
        }        
    },
    props: [ 
        'item',
        'monthIndex',
        'forecastVarInventory'
    ],
    computed: {
        getVarItems() {
            let varItems = []
            let selMonthIndex = this.selMonthIndex

            this.pointItem.values.forEach((x) => {
                let fcInvItem = this.forecastVarInventory.find('forecast', x.varGroup, true)
                let hsInvItem = this.forecastVarInventory.find('historical', x.varGroup, true)

                let item = {}
                
                item.name = x.name
                item.varid = x.varid
                item.forecastUnits = x.forecastUnits
                item.historicalUnits = x.historicalUnits
                
                item.hasForecastValue = (fcInvItem != null && fcInvItem.legend != null) 
                item.hasHistoricalValue = (hsInvItem != null && hsInvItem.legend != null)

                if (item.hasForecastValue) {
                    let lclass = fcInvItem.legend.getColorClass(x.forecast[selMonthIndex])
                    if (lclass == null) {
                        item.hasForecastValue = false
                    }
                    else {
                    item.forecastColor = lclass.color
                    item.forecastLabel = lclass.text
                    }                    
                }   
                
                if (item.hasHistoricalValue) {
                    let lclass = hsInvItem.legend.getColorClass(x.historical[selMonthIndex])
                    if (lclass == null) {
                        item.hasHistoricalValue = false
                    }
                    else {
                        item.historicalColor = lclass.color
                        item.historicalLabel = lclass.text
                    }                    
                }

                varItems.push(item)
            })

            return varItems
        },
        formatForecastValue(varItem) {
            logger.log('SummaryView::formatForecastValue()', varItem)

            let dataValue = varItem.forecast[this.selMonthIndex]
            let units = varItem.forecastUnits || ''
            return this.formatValue(dataValue, units)
        },
        formatHistoricalValue(varItem) {
            logger.log('SummaryView::formatHistoricalValue()', varItem)

            let dataValue = varItem.historical[this.selMonthIndex]
            let units = varItem.historicalUnits || ''
            return this.formatValue(dataValue, units)
        }
    },
    methods: {
        formatValue(dataValue, units) { 
            logger.log('SummaryView::formatValues()', { dataValue: dataValue, units: units })

            if (dataValue <= -9999)
                dataValue = 'No data'
            else
                dataValue = dataValue.toFixed(2).toString()
            
            let value = dataValue
            if (units != '')
                value = value + units
            
            return value
        },
    },
    watch: {
        monthIndex(val) {
            this.selMonthIndex = val
        }
    },    
}
</script>

<style>
.color-item {
    position: relative;
    display: inline-block;
    height: 15px;
    width: 15px;
    border: 1px solid rgb(0, 0, 0, 0.2)
}
</style>